import React from 'react'
import { InputGroup, Label, Input } from 'reactstrap'

export default function Period ({val, oChg, saved}) {
  return (
    <InputGroup>
      <Label htmlFor='period'>Period:</Label>
      <Input 
        type='select'
        onChange={oChg}
        value={val}
        name='period'
        id='period'
        disabled={!!saved}
      >
        {['', 1, 2, 3, 4, 5, 6, 7, 8, 9].map(per =>
          <option key={`per${per}`} value={per}>{per}</option>
          )}
      </Input>
    </InputGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/Period.js